// extracted by mini-css-extract-plugin
module.exports = {"custom-benefits-list-icon":"custom-benefits-list_custom-benefits-list-icon__ZEMs7"};